import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../i18n/LanguageContext";

export function GoogleRatingBadge() {
  const { lang, t } = useLang();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/testimonials", { params: { lang } })
      .then((r) => {
        if (r.data?.source === "google" && r.data.rating) setData(r.data);
      })
      .catch(() => {});
  }, [lang]);

  if (!data) return null;

  return (
    <a
      href="https://maps.app.goo.gl/GGpe1K5iDpwHYj2b6" target="_blank" rel="noreferrer"
      data-testid="google-rating-badge"
      className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gold/30 text-sm text-champagne hover:border-gold transition-colors duration-300"
    >
      <span className="flex gap-0.5">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className={`w-3.5 h-3.5 ${i < Math.round(data.rating) ? "fill-gold text-gold" : "text-gold/40"}`} />
        ))}
      </span>
      <span className="font-semibold">
        {(data.rating ?? 5).toLocaleString(lang === "fr" ? "fr-CA" : "en-CA", { minimumFractionDigits: 1 })}
      </span>
      <span className="text-ivory/70">— {data.user_rating_count ?? 0} {t("home_testimonials.google_reviews")}</span>
    </a>
  );
}
